import { render, staticRenderFns } from "./shareCounter.vue?vue&type=template&id=58443652&scoped=true"
import script from "./shareCounter.vue?vue&type=script&lang=js"
export * from "./shareCounter.vue?vue&type=script&lang=js"
import style0 from "./shareCounter.vue?vue&type=style&index=0&id=58443652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58443652",
  null
  
)

export default component.exports